<template>
    <div class="flats-crm-viewed-flats-section" v-if="dataItems != null">
        <div class="container">
            <div class="section-title">
                <h2>{{ flatsPage.flats_cards_info.flat_history_title}}</h2>
                <router-link to="/flats-viewing-history" class="link-route">{{ flatsPage.flats_cards_info.flat_history_btn}}</router-link>
            </div>
            <!-- {{this.dataItems}} -->
            <div class="flats-items">
                <flatsItems :flatsArr="dataItems" v-if="!isMobileChecker"></flatsItems>
                <flatsItemsList :flatsArr="dataItems" v-else></flatsItemsList>
            </div>
        </div>
    </div>
</template>

<script>
	import flatsItems from '@/components/flats-crm/flats-crm-items-viewed.vue'
	import flatsItemsList from '@/components/flats-crm/flats-crm-items-viewed-list.vue'
    import {mapGetters} from 'vuex'
    export default {
        name: 'sale-CRM-viewed-flats',
        props: ['cardData'],
        components: {
            flatsItems,
            flatsItemsList,
        },
        data () {
            return {
                dataItems: null,
                dataResp: {
                    "apartmentIds": null,
                }
            }
        },
        computed: mapGetters({
            flatsPage: 'loadFlatsPage',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
            getViewedFlats() {
                // console.log(this.$route.params.id, 'ID CADD ROUTER')
                var id = this.$route.params.id;
                var exist = localStorage.getItem('viewed_flats');
                exist = exist ? exist.split(',') : [];
                var finder = exist.find(item => item == id);

                // console.log(finder, exist, 'FLATS VIEWD');

                if (finder == undefined) {
                    this.dataResp.apartmentIds = exist;
                } else {
                    var filterExist = exist.filter(item => {
                        return item != id
                    })
                    this.dataResp.apartmentIds = filterExist;
                };
                // console.log(exist,this. dataResp,  'VIEWD FLATS 2');
                this.dataResp.apartmentIds = this.dataResp.apartmentIds.slice(-12);
                if (this.dataResp.apartmentIds.length > 0) {
                    axios.post(window.CRMProxy + '/v1/apartments', this.dataResp)
                    .then(async (response) => {
                        if (response.data.data.length != 0) {
                            this.shortArray(response.data.data)
                        } 
                    }).catch(() => {
                        this.dataItems = null;
                    });
                } else {
                    this.dataItems = null
                }
                
            },
            shortArray(items) {
                items.sort(this.sortFunc);
                items.reverse();
                // console.log(items, 'items')
                this.dataItems = items.slice(0, 4);
            },
            sortFunc(a, b) {
                var sortingArr = this.dataResp.apartmentIds;
                return sortingArr.indexOf(a.id) - sortingArr.indexOf(b.id);
            },
        },
        beforeCreate() {
        },
        created () {
            this.getViewedFlats();
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/flats-crm/flats-crm-viewed-flats.scss';
    @import '@/styles/components/flats-crm/respond/flats-crm-viewed-flats-respond.scss';
    // @import '@/styles/components/flats-crm/respond/flats-crm-btns-respond.scss';
    // @import '@/styles/respond/sales/sales-land-partials/land-flats-respond.scss';
    // @import '@/styles/respond/sales/respond-sale-item.scss';
</style>